// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"42":"6d4b476e","204":"122bc2f3","210":"e2965d95","238":"cc22b7fd"}[chunkId] + ".chunk.css";
};